<template>
  <div class="isis-container">
    <auth-forms></auth-forms>
    <desc-panel></desc-panel>
  </div>
</template>

<script>
import DescPanel from "./DescPanel";
import AuthForms from "./Forms";
export default {
  components: { DescPanel, AuthForms }
};
</script>

<style lang="scss">
$primary-blue-color: #4481eb;
$light-blue-color: #04befe;
$btn-bg-color: #5995fd;
$btn-second-bg-color: #5995fd29;
$btn-hover-bg-color: #4d84e2;
$max-width-form-ele: 380px;
$dark-txt-color: #444;
$bg-color: #fbfbfb;

.isis-container {
  position: relative;
  width: 100%;
  background-color: #fff;
  min-height: 100vh;
  overflow: hidden;

  &:before {
    content: "";
    position: absolute;
    height: 2000px;
    width: 2000px;
    top: -10%;
    right: 48%;
    transform: translateY(-50%);
    background-image: linear-gradient(
      -45deg,
      #{$primary-blue-color} 0%,
      #{$light-blue-color} 100%
    );
    transition: 1.8s ease-in-out;
    border-radius: 50%;
    z-index: 6;
  }

  *:not(.material-icons) {
    font-family: "Poppins", sans-serif !important;
  }

  @media (max-width: 870px) {
    min-height: 800px;
    height: 100vh;

    &:before {
      width: 1500px;
      height: 1500px;
      transform: translateX(-50%);
      left: 30%;
      bottom: 68%;
      right: initial;
      top: initial;
      transition: 2s ease-in-out;
    }
  }

  @media (max-width: 570px) {
    padding: 1.5rem;

    &:before {
      bottom: 72%;
      left: 50%;
    }
  }
}
</style>
